module.exports = __webpack_public_path__ + "static/media/icon_erro_rd03.54e233a0.svg";